export function inEditor() {
  return (typeof window !== 'undefined') &&
         window.location.pathname.indexOf('/editor/entries') === 0;
}
